import { render, staticRenderFns } from "./Exam.vue?vue&type=template&id=3c55871e&scoped=true&"
import script from "./Exam.vue?vue&type=script&lang=js&"
export * from "./Exam.vue?vue&type=script&lang=js&"
import style0 from "./Exam.vue?vue&type=style&index=0&id=3c55871e&prod&lang=css&"
import style1 from "./Exam.vue?vue&type=style&index=1&id=3c55871e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c55871e",
  null
  
)

export default component.exports